import React, {useState} from 'react';
import { makeStyles } from '@material-ui/styles';
import {Grid, Button, Card, Typography, CardContent, Divider} from '@material-ui/core';

import { ActionGroup, CompanyDetails, Details, PicturesDisplay } from './components';
import { getCompanyDetailsAPIReq, getOfferDetailsAPIReq, postApplyToOfferAPIReq, postValidateOffer, postRejectOffer } from 'utils/requests'
import CircularProgress from '@material-ui/core/CircularProgress';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import {CreateApplication} from './components/CreateApplication';
import {UsersTable} from '../UserList/components';
import PropTypes from 'prop-types';
import UserList from '../UserList';
import Cookies from 'universal-cookie';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const cookies = new Cookies();

let user
let status = cookies.get('isAlumni')

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));


function Alert(props) {
  return <MuiAlert
    elevation={6}
    variant="filled"
    {...props}
         />;
}

const getOfferDetails = async (isLoading, setIsLoading, id) => {
  if (isLoading){
    return getOfferDetailsAPIReq(id).then((res) => {
      if (res) {
        offer = res
        getCompanyDetailsAPIReq(res.company).then((co) => {
          company = co
          user = cookies.get('hashedID')
          setIsLoading(false);
        })
      } else {
        alert('error occurred!')
      }
    })
  }
}

let offer, company;

const OfferDetails = props => {
  const { className, match, history, ...rest } = props;
  const classes = useStyles();

  // console.log(offer)

  const [isLoading, setIsLoading] = useState(true); // integer state
  const [openErrorSnack, setOpenErrorSnack] = React.useState(false);
  const [openSuccessSnack, setOpenSuccessSnack] = React.useState(false);
  const [applicantsList, setApplicantsList] = React.useState([]);
  const [reload, setReload] = React.useState(0);
  const [openRejectDialog, setOpenRejectDialog] = React.useState(false);

  let applicantFullInformation;
  if(offer && !isLoading){
    // console.log(offer)
    offer.applications.map(application => {
      applicantFullInformation = application.applicant;
      applicantFullInformation.motivation_letter = application.motivation_letter;
      applicantsList.push(applicantFullInformation)
    });
    // console.log('app list', applicantsList);
  }

  getOfferDetails(isLoading, setIsLoading, match.params.id)

  const handleCloseSuccessSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSuccessSnack(false);
  };

  const handleCloseErrorSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenErrorSnack(false);
  };

  const handleValidateClick = () => {
    return postValidateOffer(offer.hashed_id).then((res) => {
      if (res === true)
        history.push("/unvalidated-offers")
    })
  }

  const handleRejectClick = () => {
    return postRejectOffer(offer.hashed_id).then((res) => {
      if (res === true)
        history.push("/unvalidated-offers")
    })
  }

  const handleClickOpenRejectDialog = () => {
    setOpenRejectDialog(true);
  };

  const handleCloseRejectDialog = () => {
    setOpenRejectDialog(false);
  };


  return (
    <div>
      {isLoading?
        <div className={classes.root}>
          <CircularProgress disableShrink />
        </div>
        :
        <div className={classes.root}>
          <Grid
            container
            spacing={4}
          >
            <Grid
              item
              md={8}
              xs={12}
            >
              <Details offer={offer}/>
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
              <CompanyDetails
                company={company}
                history={history}
              />
              <Card align="center">
                <CardContent>
                  {/*{(offer.didApply && offer.creator == user && !isLoading)?*/}
                  {/*  <Button*/}
                  {/*    color="primary"*/}
                  {/*    disabled*/}
                  {/*    variant="contained"*/}
                  {/*  >*/}
                  {/*  Applied*/}
                  {/*  </Button>*/}
                  {/*  :*/}
                  <CreateApplication offer={offer}/>
                  {/* // */}
                </CardContent>
              </Card>
              {!isLoading && cookies.get("isAdmin")==="true" && offer.isVisible=== false?
                <Grid
                  item
                  md={12}
                  xs={12}
                >
                  <Card align="center" >
                    <CardContent>
                      <Button variant="contained" style={{backgroundColor:"rgba(200,0,0,0.8)", color: 'white', marginRight: 100}} onClick={handleClickOpenRejectDialog}>Reject</Button>
                      <Button variant="contained" color="secondary" onClick={handleValidateClick}>Validate</Button>
                    </CardContent>
                    <Dialog
                      open={openRejectDialog}
                      TransitionComponent={Transition}
                      keepMounted
                      onClose={handleCloseRejectDialog}
                      aria-labelledby="alert-dialog-slide-title"
                      aria-describedby="alert-dialog-slide-description"
                    >
                      <DialogTitle id="alert-dialog-slide-title">{"Are you sure you want to reject this post?"}</DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                          Retrieve this post would require contacting the maintenance and support services.
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleCloseRejectDialog} color="primary">
                          No
                        </Button>
                        <Button onClick={handleRejectClick} color="primary">
                          Yes, reject this post
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </Card>
                </Grid>
                :<div></div>}

            </Grid>
          </Grid>
            
          <Grid
            container
            spacing={4}
          >

            {(offer.creator === user && !isLoading)?
              <Grid
                item
                md={12}
                xs={12}
              >
                <Card>
                  <Typography
                    align="center"
                    style={{marginTop: 20, marginBottom: 20}}
                    variant="h3"
                  >
                     Applicants
                  </Typography>
                  <Divider variant="middle" />
                  <CardContent>
                    <UsersTable
                      history={history}
                      motivationLetter
                      users={applicantsList}
                    />
                  </CardContent>
                </Card>
              </Grid>   
              :
              <div />
            }
            
          </Grid>
        </div>
      }


    </div>
  );
};


OfferDetails.propTypes = {
  history: PropTypes.object
};


export default OfferDetails;
